import Breadcrumbs from "../../../components/breadcrumbs";
import AllergyCategoryCreateForm from "./ui/allergy-category-create-form";

export default function AllergyCategoryCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Allergy Categories", href: "/admin/allergy-categories" },
          {
            label: "Create",
            href: `/admin/allergy-categories/Create`,
            active: true,
          },
        ]}
      />

      <AllergyCategoryCreateForm />      
    </main>
  );
}
